(() => {
  const CONTACT_ENDPOINT = 'https://tools.prebodigital.co.za/api/forms/d52c1990-d051-4498-93ce-df4f169d8d3e';
  const QUOTE_ENDPOINT = 'https://tools.prebodigital.co.za/api/forms/f2b14c07-b3c5-46b7-b2d1-c8435c81ea1d';
  const TIMEOUT_MS = 4000;
  const SKIP_FIELDS = new Set(['form_type', 'utf8']);

  const contactKey = (name) => {
    const match = /^contact\[(.+)\]$/.exec(name);
    return match ? match[1] : null;
  };

  const buildPayload = (form) => {
    const payload = {};
    const data = new FormData(form);

    data.forEach((value, name) => {
      if (SKIP_FIELDS.has(name) || typeof value !== 'string') return;
      const key = contactKey(name) || name;
      payload[key] = value.trim();
    });

    if (payload.name && !payload.first_name) payload.first_name = payload.name;
    if (payload.comment && !payload.message) payload.message = payload.comment;

    return payload;
  };

  const endpointFor = (form) => {
    if (form.id === 'ContactForm') return CONTACT_ENDPOINT;
    if (form.id.indexOf('RequestProductInformationForm-') === 0) return QUOTE_ENDPOINT;
    return null;
  };

  const postSubmission = (endpoint, payload) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), TIMEOUT_MS);

    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      signal: controller.signal,
    }).catch(() => {}).finally(() => window.clearTimeout(timer));
  };

  const onSubmit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const endpoint = endpointFor(form);
    if (!endpoint) return;
    if (form.dataset.preboSubmitting === 'true') return;

    event.preventDefault();
    form.dataset.preboSubmitting = 'true';

    postSubmission(endpoint, buildPayload(form)).finally(() => {
      form.submit();
    });
  };

  document.addEventListener('submit', onSubmit, true);
})();
